import React from "react";
import {
  FaFacebookSquare, FaGithubSquare, FaInstagramSquare, FaLinkedin, FaTwitterSquare
} from "react-icons/fa";
import Typist from "react-typist";
import profile from "../../Images/Lukman1.jpg";
import Information from "../Information/Information";
import "./Header.css";

const Header = () => {
  return (
    <div>
      <section className="section">
        <div className=" main d-flex align-items-center justify-content-center">
          <div className="home-body d-flex align-items-center justify-content-center">
            <div className="mt-5">
              <div className="profile-img">
                <img
                  data-aos="zoom-in"
                  className="img-fluid"
                  src={profile}
                  alt=""
                />
              </div>
              <div className="intro">
                <h1 className="about-title mt-4 font">Lukman Hossain</h1>
                <Typist className="h3 mt-3 about-title">
                  <span> Web Designer </span>
                  <Typist.Backspace count={10} delay={200} />
                  <span> Designer | Developer </span>
                  <Typist.Backspace count={11} delay={200} />
                  <span> Developer | Programmer </span>
                </Typist>
              </div>
              <div className=" d-flex justify-content-center mt-4">
                <div className="icons">
                  <a href="https://github.com/lukmanhossain" target="blank">
                    <h2>
                      <FaGithubSquare />
                    </h2>
                  </a>
                  <a
                    href="https://www.linkedin.com/in/lukmanofficial"
                    target="blank"
                  >
                    <h2>
                      <FaLinkedin />
                    </h2>
                  </a>
                  <a href="#" target="blank">
                    <h2>
                      <FaTwitterSquare />
                    </h2>
                  </a>
                  <a
                    href="https://www.facebook.com/lukmanhossain01"
                    target="blank"
                  >
                    <h2>
                      <FaFacebookSquare />
                    </h2>
                  </a>
                  <a
                    href="https://www.instagram.com/lukmanhossain01"
                    target="blank"
                  >
                    <h2>
                      <FaInstagramSquare />
                    </h2>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Information></Information>
    </div>
  );
};

export default Header;
